import { FC, memo } from 'react';

import SvgIcon, { SvgIconName } from '~src/shared/SvgIcon';

import { SegmentType } from '~src/interfaces/segment.interface';
import { AnonIcon, AnonWrapper, ImageUrl, ImageWrapper, LettersBox } from './avatarBox.sc';

export enum AvatarType {
  Company = SegmentType.Company,
  User = SegmentType.User,
  Team = SegmentType.Team,
  Admins = SegmentType.Admins,
  Anonymous = SegmentType.Anonymous,
  Group = SegmentType.Group,
  Survey = 'survey',
  Total = 'total',
}

interface OwnProps {
  size: number;
  type?: AvatarType;
  url?: string | null;
  dataUrl?: string;
  name?: string | null;
  anonymous?: boolean;
  iconName?: SvgIconName;
  borderColor?: string;
}

const AvatarBox: FC<OwnProps> = memo(
  function AvatarBox({
     size = 33,
     type = AvatarType.Company,
     dataUrl,
     url,
     name = null,
     anonymous = false,
     iconName,
     borderColor
  }) {
    let avatarEl;
    const convertLetters = (nameL: string | null, typeL: AvatarType) => {
      let initials;
      switch (typeL) {
        case AvatarType.User:
          if (nameL) {
            let namesArr = nameL.split(' ');
            namesArr = namesArr.filter((v) => v !== '');
            if (namesArr.length === 0) {
              return '??';
            }
            initials = namesArr[0].charAt(0).toUpperCase();
            initials += namesArr[namesArr.length - 1].charAt(0).toUpperCase();
          } else {
            initials = '??';
          }
          break;
        case AvatarType.Group:
        case AvatarType.Company:
          return nameL ? nameL.charAt(0).toUpperCase() : '?';
        case AvatarType.Team:
          return 't' + (nameL ? nameL.charAt(0).toUpperCase() : '?');
        case AvatarType.Admins:
          return 't' + (nameL ? nameL.charAt(0).toUpperCase() : '?');
        default:
          initials = '?';
      }
      return initials;
    };

    if (!iconName && type === AvatarType.Team) {
      iconName = 'iconPeople';
    }

    if (!iconName && type === AvatarType.Admins) {
      iconName = 'iconPeople';
    }

    if (anonymous || type === AvatarType.Anonymous) {
      avatarEl = (
        <AnonWrapper $size={size}>
          <AnonIcon name="iconAnonymous" />
        </AnonWrapper>
      );
    } else if (url) {
      avatarEl = (
        <ImageUrl
          $size={size}
          src={dataUrl || (url.startsWith('data:') ? url : `${url}?_jwt=${localStorage.jwt}`)}
          $borderColor={borderColor}
          title={name || undefined}
        />
      );
    } else {
      avatarEl = (
        <LettersBox
          $size={size}
          $typeIsUser={type === AvatarType.User}
          $borderColor={borderColor}
          title={name || undefined}
        >
          {iconName ? (
            <SvgIcon name={iconName} className="subject-icon" />
          ) : (
            <span>{convertLetters(name, type)}</span>
          )}
        </LettersBox>
      );
    }
    return <ImageWrapper $size={size}>{avatarEl}</ImageWrapper>;
  });

export default AvatarBox;
